export default __webpack_public_path__ + "static/media/icon-put.216aa799.svg";